import { Page } from '@zillow/constellation-10';

import PropertiesConstants from '../../../constants/PropertiesConstants';

import { PageHeading } from '../PageHeading';
import { PropertyTable } from '../PropertyTable';

export const PropertiesPageSkeleton = () => (
  <Page.Root css={{ backgroundColor: 'bg.screen.neutral' }}>
    <PageHeading handleAddPropertyClick={() => {}} />
    <Page.Content css={{ padding: { base: '0 {spacing.600}', xl: '0 {spacing.1200}' } }}>
      <PropertyTable
        filters={{
          subNavFilterType: PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ALL,
          searchText: PropertiesConstants.PROPERTIES_SEARCHTEXT_DEFAULT,
        }}
        setFilters={() => {}}
        isSkeletonView={true}
      />
    </Page.Content>
  </Page.Root>
);
